import {axiosRequest} from "./apiBase";
import {PagedResult} from "../common/models/pagedResult";
import {Celebrity} from "../common/models/celebrity/celebrity";

export const getCelebrityProfile = async (id: number): Promise<Celebrity> => {
    return axiosRequest(
        "GET",
        `celebrity/${id}`,
    );
}

export const getRandomCelebrity = async (requiresStarSign?: boolean): Promise<Celebrity> => {
    let url = `celebrity/randomCelebrity`;
    if(requiresStarSign)
    {
        url = `${url}?requiresStarSign=true`;
    }

    return axiosRequest(
        "GET",
        url
    );
}

export const searchCelebrity = async (term: string = "", page: number = 1, pageSize: number = 50): Promise<PagedResult<Celebrity>> => {
    return axiosRequest(
        "GET",
        `celebrity/search?term=${term}&page=${page}&pageSize=${pageSize}`,
    );
}